import type {
  TPartnerCommissionCalculationBase,
  TShopStatus,
  TShopType,
} from '../../store/types';

export const shopTypes: TShopType[] = ['regular', 'partner'];

export const shopTypeTitles: Record<TShopType, string> = {
  regular: 'Обычный',
  partner: 'Партнёрский',
};

export const shopStatusTitles: Record<TShopStatus, string> = {
  active: 'Активирован',
  verification: 'На проверке',
  inactive: 'Не активирован',
};

export const partnerCommissionCalculationBases: TPartnerCommissionCalculationBase[] = [
  'platform_commission',
  'payment_amount',
];

export const partnerCommissionCalculationBaseTitles: Record<TPartnerCommissionCalculationBase, string> = {
  platform_commission: 'Комиссия Boompay',
  payment_amount: 'Сумма платежа',
};
